import { memo } from 'react';
import { Label, type LabelProps } from '@direct-frontend/components';
import { type OpenApiSchemaYmlGoodsModerationStatus } from '#shared/api/schema';
import { getProductModerationStatusLabelProps, isAllowedProductModerationStatus } from '../../lib/status';

interface ProductModerationStatusLabelProps extends Omit<LabelProps, 'children'> {
    status: undefined | OpenApiSchemaYmlGoodsModerationStatus;
}

export const ProductModerationStatusLabel = memo<ProductModerationStatusLabelProps>(
    function ProductModerationStatusLabel({
        'data-testid': dataTestId = 'ProductModerationStatusLabel',
        status,
        ...labelProps
    }) {
        if (!isAllowedProductModerationStatus(status)) {
            return null;
        }

        return <Label data-testid={dataTestId} {...labelProps} {...getProductModerationStatusLabelProps(status)} />;
    }
);
